import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { Toaster } from "sonner";
import CodeAI from "./pages/CodeAI";
import LearnAI from "./pages/LearnAI";
import CodeEdgeAI from "./pages/CodeEdgeAI";
import SmartCodeAI from "./pages/SmartCodeAI";
import DataFixAI from "./pages/DataFix";
import BuildSiteAI from "./pages/BuildSite";
import HostEaseAI from "./pages/HostEase";
import ImageGeneratorAI from "./pages/ImageGeneratorAI";

function App() {
  return (
    <Router>
      <Toaster position="top-right" />

      <Routes>
        <Route path="/" element={<Navigate to="/rt-tracemod" replace />} />
        <Route path="/rt-tracemod" element={<CodeAI />} />
        <Route path="/xlang-tx" element={<CodeEdgeAI />} />
        <Route path="/kn-bridge" element={<LearnAI />} />
        <Route path="/codegen-ax" element={<SmartCodeAI />} />
        <Route path="/ui-renderops" element={<BuildSiteAI />} />
        <Route path="/syn-val-42" element={<DataFixAI />} />
        <Route path="/dx-pipeline" element={<HostEaseAI />} />
        <Route path="/ldm-vizCore" element={<ImageGeneratorAI />} />
      </Routes>
    </Router>
  );
}

export default App;
